import NoData from '@monorepo/common/component/NoData';
import QueryWithLoader from '@monorepo/common/component/QueryWithLoader';
import ResponsiveHeaderRow from '@monorepo/common/component/responsive/ResponsiveHeaderRow';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { ClientQueryVariables, TokenDocument, TokenQuery } from '../../graphql-operations';
import TokenDetailView, { NewTokenIcon } from './TokenDetailView';

interface TokenDetailProps {
  tokenId?: string;
  listUrl: string;
}

export default function TokenDetail({ tokenId, listUrl }: TokenDetailProps) {
  return (
    <>
      {/*Top header for small screens to go back to list*/}
      <ResponsiveHeaderRow to={listUrl}>
        <NewTokenIcon />
      </ResponsiveHeaderRow>

      {!!tokenId && (
        <QueryWithLoader<TokenQuery, ClientQueryVariables> query={TokenDocument} variables={{ id: tokenId }}>
          {({ data }) => {
            const token = data.token;

            if (!token) {
              return <Redirect to="/page-not-found" />;
            }

            return <TokenDetailView token={token} />;
          }}
        </QueryWithLoader>
      )}

      {!tokenId && <NoData text="Vyberte známku" />}
    </>
  );
}
